<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Historique des ventes</h1>
    </div>

    <div class="card">

      <div class="card-body">
        <TableWithFilters
            :columns="columns"
            :filterableFields="filterableFields"
            :row-actions="rowActions"
            :items="sales"
            @edit="onEdit"
            @details="showSaleDetails"
        >
          <template #cell-totalAmount="{ item }">
            {{ item.totalAmount | currency }}
          </template>

          <template #cell-saleDate="{ item }">
            {{ item.saleDate | dateFormat('DD/MM/YYYY à HH:mm') }}
          </template>

          <template #cell-reference="{ item }">
            <span class="text-primary fw-bold">{{ item.reference }}</span>
          </template>

          <template #cell-sellerName="{ item }">
            <span class="text-muted">{{ item.sellerName }}</span>
          </template>
        </TableWithFilters>
      </div>
      <ModalSaleDetails :sale="selectedSale" />
    </div>
  </div>
</template>
<script>
import TableWithFilters from "../../../components/TableWithFilters.vue";
import {saleColumns, saleFilterableFields, saleRowActions} from "../../../helpers/constants";
import ModalSaleDetails from "../../../components/modals/ModalSaleDetails.vue";

export default {
  name: 'Historique',
  components: {ModalSaleDetails, TableWithFilters},
  data() {
    return {
      sales: [],
      sellerId: "687c23e31e05982ddc4c2bc4", // à rendre dynamique plus tard
      selectedSale: null,
      columns: saleColumns,
      filterableFields: saleFilterableFields,
      rowActions: saleRowActions,
    };
  },
  methods: {
    showSaleDetails(sale) {
      console.log(sale);
      this.selectedSale = sale;
      $('#modal-sale-details').modal('show'); // Bootstrap 5
    },
    loadSales() {
      this.$loading(true);
      this.$http
          // .get(`/sales/pending/seller/${this.sellerId}`) // prêt pour usage réel
          .get(`/sales`) // temporairement non filtré
          .then(({ data }) => {
            this.sales = data;
          })
          .catch(err => {
            console.error("Erreur chargement ventes :", err);
          })
          .finally(() => this.$loading(false));
    },
    onEdit(item) {
      this.$router.push({ name: "edit-sale", params: { id: item.id } });
    },
    onHistory(item) {
      this.$http.get(`/sales/${item.id}/history`)
          .then(({ data }) => {
            const html = data.map(h => `
        <li><strong>${h.status}</strong> à ${moment(h.timestamp).format('DD/MM/YYYY HH:mm')}</li>
      `).join('');
            this.$swal({
              title: `Historique de la vente #${item.id}`,
              html: `<ul style="text-align:left">${html}</ul>`,
              confirmButtonText: 'Fermer'
            });
          });
    }
  },
  mounted() {
    this.loadSales();
  }
};
</script>

<style scoped>
.page-container {
  padding: 20px;
}
</style>
